import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const CommonEmailErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('email'),
})

export const EmailUsedErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('email_used'),
})

export const EmailInvalidErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('email_invalid'),
})

export const LimitExceededErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('limit_exceeded'),
})

export const VerifiedErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('email_verified'),
})

export const ExpiredCodeErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('expired_code'),
})

export const IncorrectCodeErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('incorrect_code'),
})
